module.exports = __webpack_public_path__ + "static/img/arr-right.1655c6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/arr-right.png
// module id = 74
// module chunks = 148